import * as React from "react";
import { ICellRendererParams } from "ag-grid-community";
import {
    AG_GRID_AUTOCOLUM,
    getServerSideAggregateValueFormatted,
    getUnsetGroupKeyDisplayValue,
    renderGroupCount,
} from "./render-utils";
import { UNSET_GROUP_KEY } from "helpers/server-rollup";
interface IProps extends ICellRendererParams {
    defaultDateFormat?: string;
}

export const DateCellRenderer: React.FunctionComponent<IProps> = (params): any => {
    const { colDef, value, node, column } = params;
    const { isServerSide } = colDef.cellRendererParams || {};
    let formattedValue = value;
    if (isServerSide) {
        if (colDef.aggFunc || column?.isAnyFunctionActive()) {
            formattedValue = getServerSideAggregateValueFormatted(params, formattedValue);
        } else if (formattedValue === UNSET_GROUP_KEY) {
            formattedValue = getUnsetGroupKeyDisplayValue(node, colDef);
        } else if (colDef.colId !== AG_GRID_AUTOCOLUM && !colDef.aggFunc && node.group) {
            formattedValue = "";
        }
    }
    return (
        <React.Fragment>
            {formattedValue}
            {renderGroupCount(params as any)}
        </React.Fragment>
    );
};
